import "../components/Accordion";
import "../components/KeywordSearchInput";
import "../components/YouTubeModal";

import { setupAnchorLinks, smoothScroll, smoothScrollToElement, cleanupQueryParamsFromLinks } from "../utils";

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    setupAnchorLinks();
  }, 100);

  // グローバルナビとフッターのリンクからクエリパラメータを削除
  cleanupQueryParamsFromLinks();
});

// グローバルに公開（必要に応じて）
declare global {
  interface Window {
    smoothScroll: typeof smoothScroll;
    smoothScrollToElement: typeof smoothScrollToElement;
  }
}

window.smoothScroll = smoothScroll;
window.smoothScrollToElement = smoothScrollToElement;